export default __webpack_public_path__ + "static/media/TheOmen.6204919f.mp3";